<bw-header-label-cell-legacy
  @fadeIn
  [labelCellConfig]="payrollCompleteCellConfig"
></bw-header-label-cell-legacy>
